module.exports = __webpack_public_path__ + "static/media/node-look.f927cc9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/LessonPath/static/img/node-look.png
// module id = 723
// module chunks = 1